var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8252 98.5663C76.7857 99.1127 74.6894 97.9024 74.1431 95.8631L64.099 58.3782C63.5525 56.3387 64.7629 54.2424 66.8023 53.6962C68.8418 53.1497 70.9381 54.36 71.4843 56.3995L81.5283 93.8844C82.0748 95.9237 80.8644 98.0198 78.8252 98.5663Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1742 98.5663C23.2136 99.1127 25.3099 97.9024 25.8562 95.8631L35.9002 58.3782C36.4466 56.3387 35.2363 54.2424 33.197 53.6962C31.1576 53.1497 29.0613 54.36 28.515 56.3995L18.4711 93.8842C17.9246 95.9237 19.1349 98.0198 21.1742 98.5663Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4851 56.3995C70.9387 54.36 68.8424 53.1497 66.8031 53.6962C64.7637 54.2426 63.5535 56.3389 64.1 58.3782L70.8814 83.6868H78.797L71.4851 56.3995Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1971 53.6962C31.1576 53.1497 29.0613 54.3598 28.5148 56.3995L21.2031 83.687H29.1188L35.9002 58.3784C36.4467 56.339 35.2365 54.2427 33.1971 53.6962Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 86.3098C49.1668 86.3098 48.4912 85.6342 48.4912 84.8008V67.7023C48.4912 66.8689 49.1668 66.1934 50.0002 66.1934C50.8336 66.1934 51.5092 66.8689 51.5092 67.7023V84.8008C51.5092 85.6342 50.8336 86.3098 50.0002 86.3098Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 92.9512C52.2507 92.9512 54.0752 91.1266 54.0752 88.876C54.0752 86.6253 52.2507 84.8008 50 84.8008C47.7493 84.8008 45.9248 86.6253 45.9248 88.876C45.9248 91.1266 47.7493 92.9512 50 92.9512Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2537 75.7019H7.74668C6.19102 75.7019 4.92969 74.4407 4.92969 72.8849V6.9458H95.0705V72.8849C95.0707 74.4405 93.8094 75.7019 92.2537 75.7019Z",
    fill: "#D3E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7143 48.95C37.1541 48.95 43.9959 42.1082 43.9959 33.6684C43.9959 25.2285 37.1541 18.3867 28.7143 18.3867C20.2744 18.3867 13.4326 25.2285 13.4326 33.6684C13.4326 42.1082 20.2744 48.95 28.7143 48.95Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7139 18.3867V33.6684H43.9955C43.9955 25.2285 37.1537 18.3867 28.7139 18.3867Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5678 25.4296H51.0881C50.2547 25.4296 49.5791 24.754 49.5791 23.9206C49.5791 23.0872 50.2547 22.4116 51.0881 22.4116H86.5676C87.401 22.4116 88.0766 23.0872 88.0766 23.9206C88.0768 24.7538 87.4012 25.4296 86.5678 25.4296Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5678 32.2738H51.0881C50.2547 32.2738 49.5791 31.5982 49.5791 30.7648C49.5791 29.9314 50.2547 29.2559 51.0881 29.2559H86.5676C87.401 29.2559 88.0766 29.9314 88.0766 30.7648C88.0766 31.5982 87.4012 32.2738 86.5678 32.2738Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8277 39.1181H51.0881C50.2547 39.1181 49.5791 38.4425 49.5791 37.6091C49.5791 36.7757 50.2547 36.1001 51.0881 36.1001H68.8277C69.6611 36.1001 70.3367 36.7757 70.3367 37.6091C70.3367 38.4425 69.6611 39.1181 68.8277 39.1181Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.99 69.4666H54.5695C53.6805 69.4666 52.96 68.7459 52.96 67.857V48.1389C52.96 47.2498 53.6807 46.5293 54.5695 46.5293H57.99C58.8791 46.5293 59.5996 47.25 59.5996 48.1389V67.8568C59.5998 68.7459 58.8791 69.4666 57.99 69.4666Z",
    fill: "#D83131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5379 69.4664H67.1174C66.2283 69.4664 65.5078 68.7457 65.5078 67.8568V51.6867C65.5078 50.7977 66.2285 50.0771 67.1174 50.0771H70.5379C71.427 50.0771 72.1475 50.7979 72.1475 51.6867V67.8568C72.1475 68.7457 71.4268 69.4664 70.5379 69.4664Z",
    fill: "#E94444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0857 69.4665H79.6652C78.7762 69.4665 78.0557 68.7458 78.0557 67.8569V57.8923C78.0557 57.0032 78.7764 56.2827 79.6652 56.2827H83.0857C83.9748 56.2827 84.6953 57.0034 84.6953 57.8923V67.8569C84.6953 68.7458 83.9748 69.4665 83.0857 69.4665Z",
    fill: "#EE6161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4533 60.7104H13.4318C12.5984 60.7104 11.9229 60.0348 11.9229 59.2014C11.9229 58.368 12.5984 57.6924 13.4318 57.6924H46.4533C47.2867 57.6924 47.9623 58.368 47.9623 59.2014C47.9623 60.0348 47.2867 60.7104 46.4533 60.7104Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9426 67.5546H13.4318C12.5984 67.5546 11.9229 66.879 11.9229 66.0456C11.9229 65.2122 12.5984 64.5366 13.4318 64.5366H29.9426C30.776 64.5366 31.4516 65.2122 31.4516 66.0456C31.4518 66.879 30.776 67.5546 29.9426 67.5546Z",
    fill: "#528FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2262 6.9458V72.8849C88.2262 74.4405 86.965 75.7019 85.4092 75.7019H92.2533C93.809 75.7019 95.0703 74.4407 95.0703 72.8849V6.9458H88.2262Z",
    fill: "#C0D6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3904 12.5897H1.60957C0.720703 12.5897 0 11.869 0 10.9802V2.91182C0 2.02275 0.720703 1.30225 1.60957 1.30225H98.3902C99.2793 1.30225 99.9998 2.02295 99.9998 2.91182V10.9802C100 11.869 99.2793 12.5897 98.3904 12.5897Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.39 1.30225H91.5459C92.435 1.30225 93.1555 2.02295 93.1555 2.91182V10.9802C93.1555 11.8692 92.4348 12.5897 91.5459 12.5897H98.39C99.2791 12.5897 99.9996 11.869 99.9996 10.9802V2.91182C99.9996 2.02295 99.2789 1.30225 98.39 1.30225Z",
    fill: "#0055A3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.769c732f98c13e11a005f706eee7c525.svg";
export { ForwardRef as ReactComponent };